/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ToastConfig } from './toastConfig';
import { AppointmentSyncedData } from './appointmentSyncedData';


/**
 * WebSocket notification for appointment synced.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentSyncedNotification { 
    /**
     * Always \'appointment.synced\'
     */
    readonly type: string;
    data: AppointmentSyncedData;
    toast?: ToastConfig | null;
}
export const AppointmentSyncedNotification_type_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncedNotification_data_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncedNotification_toast_Validators: ValidatorFn[] =
    [ ];


